var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCautionTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 8,
    fill: "#FCEBE3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.25,
    y: 26.9756,
    width: 9.5,
    height: 26.5,
    fill: "#02475E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3301 22.5296C39.8499 21.6973 38.9609 21.1846 38.0004 21.1846C37.0398 21.1846 36.1516 21.6973 35.6706 22.5296L19.3608 50.7793C18.8797 51.6117 18.8797 52.6371 19.3608 53.4695C19.8418 54.3019 20.7292 54.8146 21.6905 54.8146H54.3102C55.2715 54.8146 56.1597 54.3019 56.64 53.4695C57.1203 52.6371 57.1203 51.6117 56.64 50.7793L40.3301 22.5296ZM38.0004 52.1244C36.5151 52.1244 35.3102 50.9196 35.3102 49.4343C35.3102 47.9489 36.5151 46.7441 38.0004 46.7441C39.4864 46.7441 40.6905 47.9489 40.6905 49.4343C40.6905 50.9196 39.4864 52.1244 38.0004 52.1244ZM40.018 44.0532H35.9828L35.3095 30.6009H40.6905L40.018 44.0532Z",
    fill: "#F78670"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionTriangle);
export default __webpack_public_path__ + "static/media/CautionTriangle.3d5ce63079cc5910cc67b0a6cb167327.svg";
export { ForwardRef as ReactComponent };